module.exports = __webpack_public_path__ + "assets/img/loading-logo-zh.40d2b7c6.png";